/* eslint-disable react/jsx-no-useless-fragment */
import React, { forwardRef, useRef, useMemo } from 'react'
import { pick } from 'lodash-es'
import { ErrorBoundary } from 'react-error-boundary'
import clsx from 'clsx'
import { LoadingOverlay } from '@mantine/core'
import { upload } from '@vt/apis/lib-ex/v2/givrali'
import { WebBasicLayouts } from '@ow/ditto'
import {
  useTbViewStore,
  useAppEx,
  useFetchRemoteData,
  useDetailStore,
  useProjectStore,
} from '@vt/hooks'
import {
  dealLayouts as dealDetailLayouts,
  dealLayoutSlugs as dealCreateLayoutSlugs,
  fileterHiddenWhenCreateFields,
} from '@ow/ditto-core'
import Process from '../../process'
import Log from '../../log'
import Media from '../../media'
import FileDetail from '../container/content/article/detail/detail'

const Details = function (
  {
    onClickSubmitProcess,
    defaultLayouts,
    closeModal,
    isShowLog,
    hiddenSlugs = [],
  },
  ref
) {
  console.log(defaultLayouts, 'defaultLayouts')
  // 这个应该定义在秋羽的process组件
  const processFormRef = useRef(null)
  const { tbs, getDitto } = useAppEx()
  const {
    fields,
    detailConfig,
    allowDetailOperate,
    collectorConfig,
    tbId,
    tbSlug,
    showRecycle,
  } = useTbViewStore((state) =>
    pick(state, [
      'fields',
      'detailConfig',
      'collectorConfig',
      'tbId',
      'tbSlug',
      'showRecycle',
      'allowDetailOperate',
    ])
  )

  console.log(fields, 'fields')

  const {
    originalData,
    currentData,
    isReCreate,
    editableSlugs,
    editableSlugFields,
  } = useDetailStore((state) =>
    pick(state, [
      'originalData',
      'currentData',
      'isReCreate',
      'editableSlugs',
      'editableSlugFields',
    ])
  )

  const customCompsMap = useProjectStore((state) => state.customCompsMap)
  const { DetailExbandComponent } = customCompsMap || {}

  const fetchRemoteData = useFetchRemoteData()

  // 是否有工作流
  const allowFlow =
    detailConfig &&
    detailConfig.allowFlow &&
    detailConfig.allowFlow.allow &&
    !showRecycle

  // 是否显示操作日志
  const allowLog =
    detailConfig && detailConfig.allowLog && detailConfig.allowLog.allow
  const allowMedia =
    detailConfig && detailConfig.allowMedia && detailConfig.allowMedia.allow

  // 详情配置
  const editableFields = fields.filter((field) =>
    editableSlugs.includes(field.slug)
  )
  const detailLayouts = dealDetailLayouts(
    fields.filter((v) => !hiddenSlugs.includes(v.slug)),
    editableFields,
    currentData,
    detailConfig && detailConfig.detailLayouts
  )

  console.log(detailLayouts, 'detailLayouts')

  const collectorLayouts = dealDetailLayouts(
    fileterHiddenWhenCreateFields(fields),
    editableFields,
    currentData,
    collectorConfig && collectorConfig.collectorLayouts
  )

  // 字段间逻辑关系
  const conditions = (detailConfig && detailConfig.conditions) || {}

  // 整合字段逻辑关系、字段判重
  const conditionedFields = useMemo(() => {
    return fields.map((x) => {
      if (conditions[x.slug]) {
        return {
          ...x,
          logicSpec: conditions[x.slug],
        }
      }
      return x
    })
  }, [fields, conditions])

  const conditionedEditableSlugFields = useMemo(() => {
    return editableSlugFields.map((x) => {
      if (conditions[x.slug]) {
        return {
          ...x,
          opts: { ...x.opts, logicSpec: conditions[x.slug] },
        }
      }
      return x
    })
  }, [editableSlugFields, conditions])

  if (!currentData) {
    return <LoadingOverlay visible />
  }

  return (
    <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
      {/* 临时用tbId判断，需改为viewType但是还不可以 */}
      {tbSlug === 'yuanguanlibiao_0f6a33bc_7106_47e4_b13a_5b1db52bc434' ? (
        <div className="w-full h-full flex justify-center">
          <div className="h-full flex justify-center" style={{ width: '80%' }}>
            <FileDetail detailData={currentData} />
          </div>
        </div>
      ) : (
        <>
          {/* {allowLog && (
            <div className="block md:hidden w-full float-right">
              <Button
                type="primary"
                opacityType="transparent"
                style={{
                  fontSize: '13px',
                  margin: '0 -4px',
                }}
                onClick={() => {
                  setShowLog(!showLog)
                }}
              >
                {showLog ? (
                  <CloseIcon width={18} height={18} fill="currentColor" />
                ) : (
                  '查看日志'
                )}
              </Button>
            </div>
          )} */}

          <div
            className="flex-1 h-full flex flex-col relative"
            style={{ borderRight: '1px solid #E7E7E7' }}
          >
            <ErrorBoundary fallback={<div>详情信息渲染错误</div>}>
              <>
                <WebBasicLayouts
                  fields={conditionedFields}
                  // 新建时处理
                  isReCreate={isReCreate}
                  editableSlugs={
                    // 如果是重新上报，取出新建配置的所有的slug作为可编辑字段
                    isReCreate
                      ? dealCreateLayoutSlugs(collectorLayouts)
                      : editableSlugs
                  }
                  editableSlugFields={conditionedEditableSlugFields}
                  data={isReCreate ? null : currentData}
                  originalData={isReCreate ? null : originalData}
                  onClickUpload={upload}
                  layouts={
                    isReCreate
                      ? collectorLayouts
                      : defaultLayouts || detailLayouts
                  }
                  onFetchRemoteData={fetchRemoteData}
                  isHiddenMedia={allowMedia}
                  ref={ref}
                >
                  {DetailExbandComponent ? (
                    <DetailExbandComponent currentData={currentData} />
                  ) : null}
                </WebBasicLayouts>
              </>
            </ErrorBoundary>
            {allowFlow && allowDetailOperate !== false && (
              <Process
                ref={processFormRef}
                onClickSubmitProcess={onClickSubmitProcess}
                detailFormRef={ref}
                close={closeModal}
              />
            )}
          </div>

          {allowMedia && (
            <div className="hidden md:block">
              <div className="p-5 flex flex-col gap-4 h-full">
                <div
                  className="text-primary-700 font-bold pb-2"
                  style={{
                    borderBottom: '1px solid var(--ow-color-neutral-200)',
                  }}
                >
                  案件图片
                </div>
                <div
                  className="overflow-y-auto px-3 gap-4 h-9/10"
                  style={{ width: '25rem', height: '100%' }}
                >
                  <Media data={currentData} />
                </div>
              </div>
            </div>
          )}
          {allowLog && allowDetailOperate !== false && (
            <div
              className={clsx(
                isShowLog && 'hidden md:block',
                !isShowLog && 'hidden'
              )}
            >
              <div
                className="p-5 flex flex-col gap-4 h-full"
                style={
                  allowMedia && {
                    borderLeft: '1px solid var(--ow-color-neutral-200)',
                  }
                }
              >
                <div
                  className="text-primary-700 font-bold pb-2"
                  style={{
                    borderBottom: '1px solid var(--ow-color-neutral-200)',
                  }}
                >
                  操作日志
                </div>
                <div
                  className="overflow-y-auto px-3 gap-4 h-9/10"
                  style={{ width: '25.5rem', height: '100%' }}
                >
                  <Log
                    data={currentData}
                    fields={fields}
                    getDitto={getDitto}
                    tbs={tbs}
                    tbId={tbId}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default forwardRef(Details)
